<!-- <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="d-block w-100" src="../../../../../../../arenita.png" alt="First slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="../../../../../../../arenita.png" alt="2 slide">
    </div>
    <div class="carousel-item">
      <img class="d-block w-100" src="../../../../../../../arenita.png" alt="3 slide">
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div> -->

<nav>
  <!-- <div>
    <img src="../../../assets/img/auri_logo.png" alt="" height="60px">
    <a href="/cliente/inicio">Inicio</a>
    <a>Mi pedido</a>
    <a href="/cliente/paquetes">Paquetes</a>
    <a href="/cliente/proceso-v2">Como funciona?</a>
    <a href="/cliente/realizar-pago">Comprobante</a>
  </div>
  <div>
    <a>Mi cuenta</a>
  </div> -->
  <div class="d-flex align-items-center justify-content-between">
    <button class="btn m-0 btn-outline-dark">Anterior</button>
    <button class="btn m-0 btn-outline-dark">Siguiente</button>
  </div>

</nav>

<div class="bg-yellow">
  <div class="libreta">
    <div class="steps">
      <div class="step" (click)="goToStep(1)">
        <span class="circle">1</span>
        <p class="m-0 p-0">Elige tu categoria y paquete</p>
      </div>
      <!-- <img src="../../../assets/img/weui_arrow-outlined.png" alt="">
      <div class="step" (click)="goToStep(2)">
        <span class="circle" [ngClass]="{bg_disable: status<2}">2</span>
        <p class="m-0 p-0" [ngClass]="{disable: status<2}">Selecciona productos</p>
      </div> -->
      <img src="../../../assets/img/weui_arrow-outlined.png" alt="">
       <!-- (click)="goToStep(3)" -->
      <div class="step">
        <span class="circle" [ngClass]="{bg_disable: status<3}">2</span>
        <p class="m-0 p-0" [ngClass]="{disable: status<3}">Personaliza</p>
      </div>
      <img src="../../../assets/img/weui_arrow-outlined.png" alt="">
       <!-- (click)="goToStep(4)" -->
      <div class="step">
        <span class="circle" [ngClass]="{bg_disable: status<4}">3</span>
        <p class="m-0 p-0" [ngClass]="{disable: status<4}">Realiza tu pedido</p>
      </div>
    </div>

    <ng-container *ngIf="status==1">
      <div class="warning-message mt-5">
        Selecciona una familia disponible para tu grupo y revisa sus productos antes de confirmar.
      </div>

      <div *ngIf="loadingFamilias" class="warning-message mt-4">Cargando familias...</div>

      <ng-container *ngIf="!selectedFamilia">
        <div class="items mt-5" *ngIf="familias.length; else sinFamilias">
          <div class="item family-card" *ngFor="let familia of familias">
            <img [src]="familia.imagen ? buildImagePath(familia.imagen) : '../../../assets/img/auri_logo.png'" alt="">
            <h5>{{ familia.nombre }}</h5>
            <p>{{ familia.descripcion }}</p>
            <small>{{ familia.productos || 0 }} productos disponibles</small>
            <button class="btn mt-3" type="button" (click)="seleccionarFamilia(familia)">Ver productos</button>
          </div>
        </div>
        <ng-template #sinFamilias>
          <p class="mt-4">No hay familias disponibles para tu grupo.</p>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="selectedFamilia">
        <div class="d-flex align-items-center justify-content-between flex-wrap mt-5">
          <h5 class="mb-0">{{ selectedFamilia.nombre }}</h5>
          <button class="btn btn-custom" type="button" (click)="limpiarFamilia()">Cambiar categoria</button>
        </div>
        <p class="mt-3">{{ selectedFamilia.descripcion }}</p>
        <div *ngIf="loadingPaquetesFamilia" class="warning-message mt-4">Cargando productos...</div>
        <div class="items mt-5" *ngIf="paquetes.length; else sinProductos">
          <div class="item" *ngFor="let paquete of paquetes">
            <img [src]="paquete.imagen ? buildImagePath(paquete.imagen) : '../../../assets/img/auri_logo.png'" alt="">
            <h5>{{ paquete.nombre }}</h5>
            <p>{{ paquete.descripcion }}</p>
            <h6>{{ paquete.precio | currency:'MXN':'symbol':'1.0-0' }}</h6>
            <div class="d-flex justify-content-between gap-2">
              <button class="btn btn-custom" type="button" (click)="showPaqueteDetalle(paquete.id, myModal)">Ver detalle</button>
              <button class="btn" type="button" (click)="seleccionarPaquete(paquete.id)">Elegir</button>
            </div>
          </div>
        </div>
        <ng-template #sinProductos>
          <p class="mt-4">No hay productos activos en esta familia.</p>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-template #myModal>
      <div class="modal-header bg-dark">
        <h5 class="text-white">{{ selectedPaqueteNombre }}</h5>
        <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 mb-3" *ngIf="selectedPaqueteInfo">
            <p>{{ selectedPaqueteInfo.descripcion }}</p>
            <h6 *ngIf="selectedPaqueteInfo.precio">{{ selectedPaqueteInfo.precio | currency:'MXN':'symbol':'1.0-0' }}</h6>
          </div>
          <div class="col-md-4 col-sm-12 mb-3" *ngFor="let item of paqueteDetalle">
            <div class="p-3 detalle-producto">
              <img [src]="getProductoPreviewImage(item)" alt="" width="100%">
              <h6>{{ item.nombre }}</h6>
              <small *ngIf="item.tipo" class="tipo-producto">{{ item.tipo }}</small>
              <p>{{ item.descripcion }}</p>
              <div class="producto-galeria" *ngIf="getProductoGaleria(item).length">
                <img *ngFor="let imagen of getProductoGaleria(item)" [src]="buildImagePath(imagen.imagen)" alt="">
              </div>
              <div class="producto-variaciones" *ngIf="getProductoVariaciones(item).length">
                <div class="producto-variacion" *ngFor="let variacion of getProductoVariaciones(item)">
                  <strong>{{ variacion.label || variacion.nombre }}</strong>
                  <div class="variacion-configs">
                    <span *ngFor="let config of getConfiguracionesVariacion(variacion)">
                      <img *ngIf="config.imagen" [src]="buildImagePath(config.imagen)" alt="">
                      {{ config.configuracion }}
                      <small *ngIf="config.descripcion">{{ config.descripcion }}</small>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="!paqueteDetalle.length">
            <p>Este producto no tiene contenido detallado registrado.</p>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="status==2">
      <div class="warning-message mt-5">
        Resumen de paquetes seleccionados hasta el momento.
      </div>
      <ng-container *ngIf="paquetesSeleccionados.length; else noPaquetes">
        <div class="row mt-4">
          <div class="col-md-4 col-sm-12" *ngFor="let paquete of paquetesSeleccionados">
            <div class="p-3" style="border: 1px solid #000;">
              <h5>{{ paquete.paquete }}</h5>
              <p>Precio: {{ paquete.precio | currency:'MXN':'symbol':'1.0-0' }}</p>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noPaquetes>
        <p class="mt-4">Aun no has seleccionado un paquete. Regresa al paso anterior para continuar.</p>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="status==3">
      <div class="warning-message mt-5">
        Personaliza tu paquete con las opciones disponibles.
      </div>
      <div *ngIf="loadingPersonalizacion" class="warning-message mt-4">Cargando personalizacion...</div>
      <div class="row mt-4 personalizacion-grid">
        <div class="col-lg-3 col-md-4 col-sm-12 mb-4 mb-md-0">
          <p class="personalizacion-title">Elige que vas a personalizar</p>
          <button
            class="btn text-center w-100 mb-2"
            type="button"
            *ngFor="let view of personalizacionViews"
            [ngClass]="{'activeBtn': statusView===view.id}"
            (click)="selectView(view.id)">
            {{ view.label }}
          </button>
        </div>
        <div class="col-lg-5 col-md-8 col-sm-12 text-center mb-4 mb-lg-0">
          <p class="personalizacion-title">Vista previa</p>
          <div class="preview-wrapper" *ngIf="currentCatalog.length; else previewPlaceholder">
            <div
              *ngIf="currentPreviewImages.length; else previewSinImagen"
              class="carousel slide preview-carousel">
              <ol class="carousel-indicators" *ngIf="currentPreviewImages.length > 1">
                <li
                  *ngFor="let imagen of currentPreviewImages; let i = index"
                  [ngClass]="{'active': activePreviewIndex===i}"
                  (click)="setPreviewImage(i)">
                </li>
              </ol>
              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  *ngFor="let imagen of currentPreviewImages; let i = index"
                  [ngClass]="{'active': activePreviewIndex===i}">
                  <div class="preview-slide">
                    <img [src]="buildImagePath(imagen.imagen)" alt="Vista previa" class="preview-image">
                  </div>
                  <div class="carousel-caption d-block" *ngIf="imagen.titulo">
                    <p>{{ imagen.titulo }}</p>
                  </div>
                </div>
              </div>
              <button
                *ngIf="currentPreviewImages.length > 1"
                class="carousel-control-prev"
                type="button"
                (click)="previousPreviewImage()"
                aria-label="Anterior">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              </button>
              <button
                *ngIf="currentPreviewImages.length > 1"
                class="carousel-control-next"
                type="button"
                (click)="nextPreviewImage()"
                aria-label="Siguiente">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
              </button>
            </div>
            <ng-template #previewSinImagen>
              <div class="preview-slide">
                <img [src]="currentPreviewImage" alt="Vista previa" class="preview-image">
              </div>
            </ng-template>
          </div>
          <ng-template #previewPlaceholder>
            <div class="preview-wrapper preview-empty">
              <span class="text-muted small">No hay opciones disponibles para este producto.</span>
            </div>
          </ng-template>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12">
          <p class="personalizacion-title">Elige opcion</p>
          <select
            class="form-control btn-custom w-100 mb-2"
            [disabled]="!currentCatalog.length"
            [ngModel]="selectedOptionId"
            (ngModelChange)="onOptionChange($event)">
            <option [ngValue]="null" disabled>Selecciona una opcion</option>
            <option *ngFor="let option of currentCatalog" [ngValue]="getOptionValue(option)">
              {{ getOptionInputLabel(option) }}
            </option>
          </select>
          <button
            type="button"
            class="btn btn-guardar-opcion w-100"
            [disabled]="selectedOptionId==null"
            (click)="guardarOpcion()">
            Guardar opcion
          </button>
          <small *ngIf="selectedOptionName" class="selected-option-label d-block mt-2">
            Seleccion actual: {{ selectedOptionName }}
          </small>
          <p *ngIf="selectedOptionDescription" class="selected-option-description mt-2">
            {{ selectedOptionDescription }}
          </p>
          <small *ngIf="!currentCatalog.length" class="text-muted d-block mt-2">
            Agregaremos opciones muy pronto.
          </small>
        </div>
      </div>

      <div class="mt-5" style="border: 1px solid #000; padding: 20px;">
        <h5>Dedicatoria</h5>
        <form [formGroup]="dedicatoriaForm" (ngSubmit)="enviarDedicatoria()">
          <div class="form-row">
            <div class="form-group col-md-4 col-sm-12">
              <label for="nombreDed">Nombre</label>
              <input id="nombreDed" type="text" class="form-control" formControlName="nombre">
            </div>
            <div class="form-group col-md-4 col-sm-12">
              <label for="dirigido">Dirigido a</label>
              <input id="dirigido" type="text" class="form-control" formControlName="dirigido">
            </div>
            <div class="form-group col-md-4 col-sm-12">
              <label for="texto">Mensaje</label>
              <input id="texto" type="text" class="form-control" formControlName="texto">
            </div>
          </div>
          <div class="d-flex gap-3">
            <button class="btn" type="submit">Guardar dedicatoria</button>
            <button class="btn btn-custom" type="button" (click)="omitirDedicatoria()">Omitir dedicatoria</button>
          </div>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="status==4">
      <div class="warning-message mt-5">
        Una vez procesado el pedido ya no hay cambios. Revisa tu seleccion, contrato y condiciones antes de continuar.
      </div>

      <div class="row g-4 mt-5">
        <div class="col-lg-6 col-md-12">
            <div class="resumen-card">
              <h5 class="mb-3">Resumen de personalizacion</h5>

            <div class="resumen-group" *ngIf="personalizacionSeleccionada.length">
              <p class="resumen-label">Opciones seleccionadas</p>
              <div class="resumen-item" *ngFor="let seleccion of personalizacionSeleccionada">
                <span>{{ seleccion.variacion_label || seleccion.variacion_nombre }}: {{ seleccion.nombre }}</span>
                <button type="button" class="btn btn-link text-danger p-0" (click)="eliminarConfiguracionSeleccion(seleccion.id)">Quitar</button>
              </div>
            </div>

            <div class="resumen-group" *ngIf="!personalizacionSeleccionada.length">
              <p class="resumen-label">Molduras</p>
              <p class="empty-label" *ngIf="!moldurasSeleccionadas.length">Aun no has elegido moldura.</p>
              <div class="resumen-item" *ngFor="let moldura of moldurasSeleccionadas">
                <span>{{ moldura.nombre }}</span>
                <button type="button" class="btn btn-link text-danger p-0" (click)="eliminarMolduraSeleccion(moldura.id || moldura.moldura_id || moldura.moldura)">Quitar</button>
              </div>
            </div>

            <div class="resumen-group" *ngIf="!personalizacionSeleccionada.length">
              <p class="resumen-label">Placas</p>
              <p class="empty-label" *ngIf="!placasSeleccionadas.length">Aun no has elegido placa.</p>
              <div class="resumen-item" *ngFor="let placa of placasSeleccionadas">
                <span>{{ placa.nombre }}</span>
                <button type="button" class="btn btn-link text-danger p-0" (click)="eliminarPlacaSeleccion(placa.id || placa.placa_id || placa.placa)">Quitar</button>
              </div>
            </div>

            <div class="resumen-group" *ngIf="!personalizacionSeleccionada.length">
              <p class="resumen-label">Colores</p>
              <p class="empty-label" *ngIf="!coloresSeleccionados.length">Aun no has elegido color.</p>
              <div class="resumen-item" *ngFor="let color of coloresSeleccionados">
                <span>{{ color.nombre }}</span>
                <button type="button" class="btn btn-link text-danger p-0" (click)="eliminarColorSeleccion(color.id || color.color_id || color.color)">Quitar</button>
              </div>
            </div>

            <div class="resumen-group">
              <p class="resumen-label">Dedicatorias</p>
              <p class="empty-label" *ngIf="!dedicatoriasSeleccionadas.length">Sin dedicatoria.</p>
              <div class="resumen-item" *ngFor="let dedicatoria of dedicatoriasSeleccionadas">
                <span>{{ dedicatoria.nombre }}</span>
                <button type="button" class="btn btn-link text-danger p-0" (click)="eliminarDedicatoriaSeleccion(dedicatoria.id || dedicatoria.dedicatoria)">Quitar</button>
              </div>
            </div>

            <div class="total-resumen mt-4">
              <p>Total estimado</p>
              <h4>{{ totalResumen | currency:'MXN':'symbol':'1.0-0' }}</h4>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="pago-card">
            <h5>Completa tu pago</h5>
            <p class="small mb-3">Resumen de compra</p>
            <div class="total-resumen mt-4">
              <p>Total estimado</p>
              <h4>{{ totalResumen | currency:'MXN':'symbol':'1.0-0' }}</h4>
            </div>
            <button
              class="btn mt-3"
              type="button"
              [disabled]="!tokenActual"
              (click)="redirigirAPagos()">
              Abrir modulo de pago
              <img src="../../../assets/img/arrow  next.png" alt="">
            </button>
          </div>
        </div>
      </div>

      <div class="mt-5 contrato-final">
        <h5>Contrato y condiciones</h5>
        <iframe src="assets/contratos/contrato_auri.pdf"></iframe>
      </div>

      <button class="btn mt-5 mb-3" type="button" (click)="solicitarPedido()">
        Realiza tu pedido
        <img src="../../../assets/img/arrow  next.png" alt="">
      </button>
    </ng-container>
  </div>
</div>
